import React from 'react';

const Profile = () => {
    return (
        <div className='user-profile'>
            this is a Profile page
        </div>
    );
};

export default Profile;